import React, { useRef, useEffect } from 'react';
import moment from 'moment';
import { getLastSegment, displayStatus } from 'src/helpers/helperFunctions';
import modalCloseIcon from 'src/assets/images/share-modal-close-icon.svg'
import headerLogo from 'src/assets/images/shifara-green-logo.png';
import printingIcon from 'src/assets/images/printing-icon.png'
import generatePDF from "react-to-pdf";
import { Margin } from 'react-to-pdf';
import { CURRENCY } from 'src/lib/constans';


interface IPharmOrder {
    _id: string;
    firstName: string;
    lastName: string;
    totalAmount: number;
    status: string;
    serialOrderId: string;
    createdAt: string;
    email: string;
    mobile: string;
};

interface Props {
    onClose?: () => void;
    headerFields?: String[];
    columnsWidth?: any;
    allOrders?: IPharmOrder[]
}

const PrintModal: React.FC<Props> = ({ onClose, headerFields, columnsWidth = "auto", allOrders }) => {

    const tableRef: any = useRef()

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        }
    }, [])

    return (
        <div className='bg-[#00000080] py-[50px] overflow-y-auto fixed top-0 left-0 z-[999] w-full h-[100vh] ' onClick={(e) => {
            if (e.target === e.currentTarget && onClose) {
                onClose()
            }
        }}>
            <div className='relative bg-[#E3E3E3] rounded-lg mx-auto items-start w-[70%]' >
                <button onClick={onClose} className="absolute -top-2" style={{ right: "-10px" }}>
                    <img
                        src={modalCloseIcon}
                        alt=""
                        width="20px"
                    />
                </button>
                <div className='w-full h-full'>
                    <div className='print-modal-width-logo relative p-5 pb-0'>
                        <button onClick={() => {
                            let style = `
                            @font-face {
                            font-family: Poppins-Regular;
                            src: url(../fonts/Poppins/Poppins-Regular.ttf);
                            }

                            .font-Poppins-Regular {
                           font-weight: 500;
                            }
                            .thead-light-table {
                            background-color: #00443F;
                            min-height: 55px;
                            border-radius: 5px;
                            color: #ffff;
                            display: grid;
                            margin-bottom: 1rem;
                            box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 0px 3px 1px;
                            margin-left: 0;
                            margin-right: 0;
                            padding-right: 4px;
                            }
                            
                            .thead-light-table li {
                            display: flex;
                            align-items: center;
                            justify-content: left;
                            }

                            .tbody-light-table li {
                            display: flex;
                            align-items: center;
                            justify-content: left;
                            padding-top: 0.5rem;
                            padding-bottom: 0.5rem;
                            flex-wrap: wrap;
                            }

                            .tbody-light-table {
                            background-color: #ffff;
                            min-height: 55px;
                            border-radius: 5px;
                            color: #2F2F31;
                            margin-bottom: 1rem;
                            box-shadow: 0px 0px 15px -15px rgba(0, 0, 0, 0.69);
                            display:grid;
                            }

                            .thead-light-table li:last-child,
                            .tbody-light-table li:last-child {
                            justify-content: center;
                            padding: 0 !important;
                            }
                            .tbody-light-table li {
                            border-left: 2px solid #1c1c1c50;
                            padding-left: 0.5rem;
                            }

                            .thead-light-table li {
                            border-left: 2px solid #ffffff9d;
                            padding-left: 0.5rem;
                            font-weight: 600;
                            }

                            .thead-light-table li:first-child {
                            border-left: none;
                            }

                            .tbody-light-table,
                            li:first-child {
                            border-left: none;
                            }
                            .tbody-light-table li {
                                display: flex;
                                align-items: center;
                                justify-content: left;
                                padding-top: 0.5rem;
                                padding-bottom: 0.5rem;
                                flex-wrap: wrap;
                                }

                                .tbody-light-table {
                                background-color: #ffff;
                                min-height: 55px;
                                border-radius: 5px;
                                color: #2F2F31;
                                margin-bottom: 1rem;
                                box-shadow: 0px 0px 15px -15px rgba(0, 0, 0, 0.69);
                                }

                                .customer-table-wrapper-body {
                                border: 1px solid #1C1C1C;
                                border-radius: 0.5rem;
                                }

                                .thead-light-table,
                                .tbody-light-table {
                                padding-left: 0;
                                margin-left: 0.3rem;
                                margin-right: 0.3rem;
                                margin-left: 0;
                                margin-right: 0;
                                }

                                .thead-light-table li:last-child,
                                .tbody-light-table li:last-child {
                                justify-content: center;
                                padding: 0 !important;
                                }
                                .font-size-16px {
                                font-size:14px;
                                }
                                .font-poppins-Medium {
                                font-weight: 600;
                                }
                                .font-Poppins-SemiBold {
                                font-weight: 700;
                                }
                            `

                            const content = tableRef.current;
                            const printWindow = window.open('', '', `height=${window.innerHeight},width=${window.innerWidth}`);

                            if (printWindow) {
                                printWindow.document.write('<html><head><title>Print</title></head><body>');
                                printWindow.document.write('<style>' + style + '</style>');
                                printWindow.document.write(content.innerHTML);
                                printWindow.document.write('</body></html>');
                                printWindow.document.close();
                                printWindow.print();
                            }

                        }} disabled={!allOrders?.length} className='print-btn absolute right-[20px] font-size-15px text-white font-poppins-Medium'>
                            <img src={printingIcon} className='w-[1vw]' alt="print-icon" />
                            <span>Print</span>
                        </button>
                        <img src={headerLogo} alt="" />
                    </div>
                    <div className='print-modal-width-inner p-5 rounded-lg' id='printable-element' ref={tableRef}>
                        <ul className="thead-light-table sticky top-0" style={{ gridTemplateColumns: columnsWidth }}>
                            {
                                headerFields?.map((item, index) => {
                                    return (
                                        <li className='font-size-16px font-Poppins-SemiBold' key={index} >{item}</li>
                                    )
                                })
                            }
                        </ul>
                        <div className='tbody-content-height tbody-content-height-allOrder'>
                            {allOrders?.map((item: IPharmOrder, index: number) => (
                                <ul key={index} className='font-size-16px tbody-light-table font-Poppins-Regular' style={{ gridTemplateColumns: "9% 12% 15% 25% 17% 10% 12%", display: 'grid' }}>
                                    <li>
                                        {`${getLastSegment(item?.serialOrderId)}`}
                                    </li>
                                    <li>{moment(item?.createdAt).format("DD-MM-YYYY")}</li>
                                    <li className="capitalize">{`${item?.firstName || ""} ${item?.lastName || ""}`}</li>
                                    <li>{item?.email || "-"}</li>
                                    <li>{item?.mobile || "-"}</li>
                                    <li>{`${CURRENCY} ${item?.totalAmount || 0}`}</li>
                                    <li
                                        style={{
                                            paddingLeft: 0,
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <span style={{
                                            backgroundColor: displayStatus(item?.status)?.bgColor,
                                            color: displayStatus(item?.status)?.color,
                                        }} className='py-1 px-4 font-size-13px font-Poppins-SemiBold capitalize rounded'>{displayStatus(item?.status)?.text || ""}</span>
                                    </li>
                                </ul>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PrintModal